import { h, Component } from 'preact';
import { connect } from 'redux-zero/preact';
import actions from '../store/actions';


class Option extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.addLeaveEvent(true);
    }

    revealNextText() {
        let nextButton = document.getElementById('nextButton');
        nextButton.classList.add('next-btn-active');
        nextButton.classList.add('neo-btn-next');
        nextButton.disabled = false
    }

    /**
     *
     * @param {*} content
     * @param {*} option
     * @return void
     */
    parentFocus(content, option) {
        let parentBtn = document.getElementById(`neooption${option.option_mode}${content.id}`);
        parentBtn.focus();
    }

    selected(id, type) {
        const { selectedOption } = this.props;

        return id == selectedOption && type != "image" ? 'active' : '';
    }

    render() {
        const { contents, option } = this.props;
        return (
            <div className={`et-max-w-xs et-mx-auto et-mt-5 lg:et-mt-10 notranslate ${option.option_mode == 'image' ? 'et-grid et-grid-cols-2 et-justify-center' : 'et-flex et-flex-col'}`}>
                {contents.length ? contents.map((content, index) => (
                    <div className={`${option.option_mode == 'image' ? `et-flex et-justify-center ${contents.length == 3 && index == 2 ? 'et-col-span-2' : ''}` : 'et-w-full'}`}>
                        <button tabIndex={index + 1} className={`neo-option ${this.selected(content.id, option.option_mode)} ${option.option_mode == 'image' ? 'neo-option--image' : 'et-w-full'}`} id={`neooption${option.option_mode}${content.id}`} onClick={(e) => { this.props.changeSelectedOption(content.id); this.revealNextText(); e.target.focus() }} key={content.id}>
                            {
                                option.option_mode == 'image' ?
                                    <img src={content.content} onClick={(e) => this.parentFocus(content, option)} />
                                    :
                                    content.text
                            }
                        </button>
                    </div>
                )) : <div>Load Question ...</div>}
            </div>
        )
    }
}

const mapToProps = ({ selectedOption }) => ({ selectedOption })

export default connect(mapToProps, actions)(Option)